import React from "react";
import { useAlert } from "../contexts/AlertProvider";
import Portal from "@mui/material/Portal";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

// Portal renders the alerts under document.body, outside any app subtree a
// modal Dialog marks aria-hidden, so screen readers still announce them.
// They stack bottom-right in one live region (clear of the tabs and header
// actions); each one times out on its own.
const AlertBar = () => {
  const { alerts, dismiss } = useAlert();

  return (
    <Portal>
      <Box
        aria-live="polite"
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          zIndex: (theme) => theme.zIndex.snackbar,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          width: "min(420px, calc(100vw - 32px))",
          pointerEvents: "none",
        }}
      >
        {alerts.map((item) => (
          <Snackbar
            key={item.id}
            open
            autoHideDuration={item.duration}
            onClose={(event, reason) => {
              if (reason === "clickaway") return;
              dismiss(item.id);
            }}
            sx={{
              position: "static",
              transform: "none",
              left: "auto",
              right: "auto",
              bottom: "auto",
              width: "100%",
              justifyContent: "flex-end",
              pointerEvents: "auto",
            }}
          >
            <Alert
              onClose={() => dismiss(item.id)}
              action={
                typeof item.action === "function"
                  ? item.action(() => dismiss(item.id))
                  : item.action || undefined
              }
              severity={item.severity}
              variant="outlined"
              sx={{ width: "100%", boxShadow: (theme) => theme.tokens?.shadowLg }}
            >
              <AlertTitle>{item.title}</AlertTitle>
              {item.detail}
            </Alert>
          </Snackbar>
        ))}
      </Box>
    </Portal>
  );
};

export default AlertBar;
